<svelte:head>
  <title>About</title>
</svelte:head>
 
<h1>About Squaredojo</h1> 